module.exports = __webpack_public_path__ + "img/E_SDG_Icons-11.5dceda01.jpg";